module.exports = __webpack_public_path__ + "media/V57.5e916783.mp4";